import "./intro.scss"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { init } from 'ityped';
import {useEffect, useRef} from "react";

export default function Intro({theme, setTheme}) {
     const textRef = useRef();

     useEffect(() => {
      init( textRef.current, {
        showCursor: true,
        backDelay: 1500,
        backSpeed: 60,
        strings: ["Developer", "Designer","Editor"],
      });
     },[])

  return (
    <div className={"intro "+ (theme && "dark")} id="intro"> 
     <div className="left">
        <div className="imgContainer">
          <img src="assets/bitemoji.png" alt="myimage" />
        </div>
     </div>
     <div className="right">
      <div className="wrapper">
        <h2>Hey There !!, I'm</h2>
        <h1>ANANYA JAIN</h1>
        <h3 >Freelance <span ref={textRef} ></span></h3>
      </div>

      <a href="#works">
        <KeyboardArrowDownIcon className="icon"/>
      </a>

     </div>
    </div>
  )
}
